import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { useParams } from "react-router-dom";
import { CMSCollection } from "../../../../../models/CMS/cmsCollection";
import { Form, Formik } from "formik";
import { DetailPageHeader } from "../../../ui-components/pageLayout/DetailPageHeader";
import { store } from "../../../store";
import {
  ClearCollectionAction,
  DeleteCollectionAction,
  GetCollectionAction,
  getMediaCollectionSelector,
  getMediaCollectionsSelector,
  SetCollectionAction,
  UpdateCollectionAction,
} from "../../../store/reducers/cmsReducer";
import MediaCollectionBasicInformationAccordion from "./accordions/MediaCollectionBasicInformationAccordion";
import MediaCollectionMediasAccordion from "./accordions/MediaCollectionMediasAccordion";

const UpdateCollectionSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required*"),
});

export const MediaCollection: React.FC = () => {
  const collections = useSelector(getMediaCollectionsSelector);
  const collection = useSelector(getMediaCollectionSelector);
  const [isDeleting, setIsDeleting] = useState<boolean>(false);
  const history = useNavigate();
  const params = useParams();

  useEffect(() => {
    if (!collection && !isDeleting) {
      const foundCollection = collections?.find(
        (collection) => collection.getUniqueId() === params.id
      );
      if (foundCollection) {
        store.dispatch(SetCollectionAction(foundCollection.serialize()));
      } else {
        if (params.id) {
          store.dispatch(GetCollectionAction(params.id));
        } else {
          console.error("Collection ID is missing.");
        }
      }
    } else if (!collection && isDeleting) {
      redirect();
    }
  }, [collections, collection]);

  useEffect(() => {
    return () => {
      store.dispatch(ClearCollectionAction());
    };
  }, []);

  const submitDeleteCollection = () => {
    setIsDeleting(true);
    if (params.id) {
      store.dispatch(DeleteCollectionAction(params.id));
    } else {
      console.error("Collection ID is missing.");
    }
  };

  const submitUpdateCollection = (values: CMSCollection) => {
    // Pass the serialized object, not the class instance
    store.dispatch(UpdateCollectionAction(values.serialize()));
  };

  const redirect = () => {
    history("/admin/offerings/media-collections/");
  };

  return (
    <>
      {collection && (
        <>
          <Formik
            initialValues={collection}
            validationSchema={UpdateCollectionSchema}
            onSubmit={(values: CMSCollection) => {
              submitUpdateCollection(values);
            }}
          >
            {({ handleSubmit, values }) => (
              <Form>
                <DetailPageHeader
                  title="Collection Metadata"
                  onDelete={submitDeleteCollection}
                  entity={collection}
                  onBack={redirect}
                />
                <MediaCollectionBasicInformationAccordion />
                <MediaCollectionMediasAccordion />
              </Form>
            )}
          </Formik>
        </>
      )}
    </>
  );
};
